import 'react-datetime/css/react-datetime.css';
import _ from 'lodash'
import React, { Component } from 'react';
import DatetimePicker from 'react-datetime';
import { connect } from 'react-redux';
import { getTranslate, } from 'react-localize-redux';
import Select, { components } from 'react-select';
import moment from 'moment';
import { isLangKeyExisted } from '../lang'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactS3Uploader from 'react-s3-uploader/ReactS3Uploader';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { verifyThe1, clearThe1Verify } from '../actions/the1';

function toDatetimeLocal(date) {
    var ten = function (i) {
        return (i < 10 ? '0' : '') + i;
    },
        YYYY = date.getFullYear(),
        MM = ten(date.getMonth() + 1),
        DD = ten(date.getDate()),
        HH = ten(date.getHours()),
        II = ten(date.getMinutes()),
        SS = ten(date.getSeconds())
        ;
    return YYYY + '-' + MM + '-' + DD + 'T' + HH + ':' + II + ':' + SS;
};
export const renderTextField = ({ input, id, label, type, pattern, inputmode, placeholder, className, labelClassName, inputClassName, autocomplete, readOnly, translate, meta: { touched, error } }) => {
    let customClassName = className ? className : '';
    let labelCustomClassName = labelClassName ? labelClassName : '';
    let inputCustomClassName = inputClassName ? inputClassName : '';
    let customAutoComplete = autocomplete ? autocomplete : '';
    let errorText = (translate && isLangKeyExisted(error)) ? translate(error) : error
    return (
        <div className={`form-group ${error ? "has-danger" : ""} ${customClassName}`}>
            {label && <label className={`form-control-label ${labelCustomClassName}`}>{label} {error && <small className="color-red ml-1">{errorText}</small>}</label>}
            <input {...input} id={id} className={`form-control ${inputCustomClassName}`} type={type} placeholder={placeholder} autoComplete={customAutoComplete} readOnly={readOnly} pattern={pattern} inputMode={inputmode}
                onChange={(e) => {
                    if (type === "datetime-local") {
                        input.onChange(toDatetimeLocal(new Date(e.target.value)))
                    } else {
                        input.onChange(e)
                    }
                }} />
            {!label ? error ? <small className="color-red ml-1">{errorText}</small> : null : null}
        </div>
    );
};

export const renderHTMLSelectField = ({ input, label, placeholder, className, labelClassName, inputClassName, readOnly, meta: { touched, error }, children }) => {
    let customClassName = className ? className : '';
    let labelCustomClassName = labelClassName ? labelClassName : '';
    let inputCustomClassName = inputClassName ? inputClassName : '';
    // let customAutoComplete = autocomplete? autocomplete: '';
    return (
        <div className={`form-group ${error ? "has-danger" : ""} ${customClassName}`}>
            {label && <label className={`form-control-label ${labelCustomClassName}`}>{label}</label>}{error && <small className="color-red ml-1">{error}</small>}
            <select {...input} className={`form-control ${inputCustomClassName}`} placeholder={placeholder} readOnly={readOnly} onChange={input.onChange}>
                {children}
            </select>
        </div>
    );
};

export const renderTextArea = ({ input, rows = 5, label, type, placeholder, className, labelClassName, inputClassName, autocomplete, style, meta: { touched, error } }) => {
    let customClassName = className ? className : '';
    let labelCustomClassName = labelClassName ? labelClassName : '';
    let inputCustomClassName = inputClassName ? inputClassName : '';
    let customAutoComplete = autocomplete ? autocomplete : '';
    return (
        <div className={`form-group ${error ? "has-danger" : ""} ${customClassName}`}>
            {label && <label className={`form-control-label ${labelCustomClassName}`}>{label}</label>}
            <textarea {...input} rows={rows} className={`form-control ${inputCustomClassName}`} type={type} placeholder={placeholder} autoComplete={customAutoComplete} style={style} />
        </div>
    );
}

export class SelectField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOption: this.props.input || this.props.initValue || ''
        }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(selectedOption) {
        const { input, onChange } = this.props;
        this.setState({ selectedOption });
        if (input) {
            input.onChange(selectedOption ? selectedOption.value : null);
        }
        if (typeof onChange === "function") {
            onChange(selectedOption.value);
        }
    }

    render() {
        const { placeholder, options, valueKey, labelKey, multi, clearable, searchable } = this.props; //input, postChange, meta: {touched, error}
        const { selectedOption } = this.state;
        // console.log ("selectedOption: " + selectedOption);
        // const value = selectedOption && selectedOption.value;
        // console.log (value);
        return (
            <Select
                className=""
                // onChange={(value) => {input.onChange(value? value[valueKey]: null);}}
                onChange={this.handleChange}
                value={selectedOption}
                options={options}
                valueKey={valueKey ? valueKey : 'value'}
                labelKey={labelKey ? labelKey : 'label'}
                placeholder={placeholder}
                multi={typeof multi !== "undefined" ? multi : true}
                clearable={typeof clearable !== "undefined" ? clearable : true}
                searchable={typeof searchable !== "undefined" ? searchable : true}
            >
            </Select>
        );
    }
}

export class RenderSelectField extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedOption: ''
        }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(selectedOption) {
        const { input, postChange } = this.props;
        this.setState({ selectedOption });
        input.onChange(selectedOption ? selectedOption.value : null);
        if (typeof postChange === "function") {
            postChange(selectedOption.value);
        }
    }

    render() {
        const { placeholder, className, formClassName, styles, input, label, options, valueKey, labelKey, multi, clearable, searchable, meta } = this.props; //input, postChange,  touched, error }
        const { selectedOption } = this.state;
        const value = selectedOption === '' ? (input.value ? (options[input.value - 1] || _.find(options, (o) => o.value === input.value) || _.find(options, (o) => o.value === input.value.value)) : '') : selectedOption;
        const err = meta ? meta.error : null;
        const stylesInput = styles || {}
        if (!clearable) {
            stylesInput.indicatorSeparator = () => ({
                display: 'none'
            })
        }
        return (
            <div className={`form-group ${className} ${err ? "has-danger" : ""}`}>
                <label className="form-control-label" htmlFor={label}>{label}</label>
                <Select
                    // onChange={(value) => {input.onChange(value? value[valueKey]: null);}}
                    onChange={this.handleChange}
                    defaultValue={value}
                    options={options}
                    valueKey={valueKey ? valueKey : 'value'}
                    labelKey={labelKey ? labelKey : 'label'}
                    placeholder={placeholder}
                    multi={typeof multi !== "undefined" ? multi : true}
                    clearable={typeof clearable !== "undefined" ? clearable : true}
                    searchable={typeof searchable !== "undefined" ? searchable : true}
                    className={`react-select-container ${formClassName}`}
                    classNamePrefix="react-select"
                    styles={styles}
                    components={{ DropdownIndicator }}
                >
                </Select>
            </div>
        );
    }
}

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <FontAwesomeIcon icon={faChevronDown} />
        </components.DropdownIndicator>
    );
};

export class renderDateTimeField extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    // componentDidMount() {
    //     const {init, input} = this.props;
    //     if (typeof init !== "undefined" || input) {
    //         let temp = moment(init? init: input.value).format("DD MMMM YYYY");
    //         this.setState({value: temp});
    //         input.onChange(temp);
    //     }
    // }

    // componentWillReceiveProps(nextProps) {
    //     if (this.props.input.value !== nextProps.input.value) {
    //         let temp = moment(nextProps.input.value);
    //         this.setState({value: temp});
    //         nextProps.input.onChange(temp);
    //     }
    // }

    renderInput(props, openCalendar, closeCalendar) {
        return (
            <div className="rdt">
                <input id="datetimeInput" {...props} />
                <FontAwesomeIcon icon={["fal", "calendar-alt"]} onClick={() => document.getElementById('datetimeInput').click()} />
            </div>
        );
    }

    render() {
        const { input, label, dateFormat, timeFormat, isValidDateFunc, className, labelClassName, meta: { error } } = this.props;
        // const {value} = this.state;
        let isValidDate = {};
        let customClassName = className ? className : '';
        let labelCustomClassName = labelClassName ? labelClassName : '';
        if (typeof isValidDateFunc === "function") {
            isValidDate = {
                isValidDate: isValidDateFunc
            }
        }
        return (
            <div className={`form-group ${error ? "has-danger" : ""} ${customClassName}`}>
                {label ? <label className={`form-control-label ${labelCustomClassName}`}>{label}</label> : null}
                <DatetimePicker
                    onChange={e => { this.setState({ value: e }); console.log("onchange:", e); input.onChange(e) }}
                    dateFormat={typeof dateFormat !== "undefined" ? dateFormat : "DD MMM YYYY"}
                    timeFormat={typeof timeFormat !== "undefined" ? timeFormat : "HH:mm"}
                    timeConstraints={{ minutes: { step: 5 } }}
                    {...isValidDate}
                    value={input ? moment(input.value) : this.state.value}
                    inputProps={{ readOnly: true }}
                    disableOnClickOutside={false}
                    renderInput={this.renderInput}
                />
            </div>
        );
    }
}

export const renderUrlTextField = ({ input, readOnly, meta: { touched, error } }) => {

    return (
        <div className="input-group mb-3">
            <div className="input-group-prepend">
                <span className="input-group-text">https://thebeautrium.com/blog/</span>
            </div>
            <input {...input} type="text" className="form-control" autoComplete="off" readOnly={readOnly} />
            {error && <small class="form-control-feedback" style={{ color: "red", width: "100%" }}>{error}</small>}
        </div>
    );
};

class _UploadField extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filename: '',
        }

        this.onPreProcess = this.onPreProcess.bind(this);
        this.onUploadFinish = this.onUploadFinish.bind(this);
    }

    onPreProcess(file, next) {
        // this.props.load(true);
        if (file.size < 10485760) {
            this.props.load(true);
            next(file);
        } else {
            // this.props.load(false);
            this.setState({ fileTooBig: true });
        }
    }

    onUploadFinish(signResult, file) {
        // this.props.load(false);
        const { input } = this.props;
        this.setState({ filename: file.name });
        input.onChange(signResult.publicUrl);
        this.props.load(false);
    }

    render() {
        const { label, s3path } = this.props;
        if (!s3path) {
            return <div>s3path is required</div>
        }
        return (
            <div className="upload-form w-100">
                <label className="label-control w-100">{label}</label>
                <div className="form-group row mx-0">
                    <input className="col-9 form-control" type="text" placeholder="" value={this.state.filename} readOnly onClick={(e) => { e.preventDefault(); this.imageUpload.click(); }} />
                    <button className="col-3 btn btn-white" onClick={(e) => { e.preventDefault(); this.imageUpload.click(); }}>เลือกภาพ</button>
                </div>
                <label style={{ display: 'none' }} ref={input => this.imageUpload = input}>
                    <ReactS3Uploader
                        style={{ display: 'none' }}
                        signingUrl="/s3/sign"
                        signingUrlMethod="GET"
                        accept="image/*"
                        preprocess={this.onPreProcess}
                        onFinish={this.onUploadFinish}
                        // signingUrlHeaders={{ authorization: localStorage.getItem('token') }}
                        signingUrlWithCredentials={true}
                        uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }}  // this is the default
                        contentDisposition="auto"
                        scrubFilename={(filename) => moment().format("YYYY-MM-DD_HH-mm") + "-" + filename.replace(/[^\w\d_\-.]+/ig, '')}
                        server={process.env.NODE_ENV === "development" ? "https://api.thebeautrium.com" : `/ssr`}
                        s3path={s3path}
                    />
                </label>
            </div>
        );
    }
}

export const UploadField = _UploadField;

const the1Types = [
    { value: 'mobile', label: 'หมายเลขโทรศัพท์' },
    { value: 'national_id', label: 'หมายเลขบัตรประชาชน' },
    { value: 'card_no', label: 'หมายเลข The1' },
];

class _The1Field extends Component {

    constructor(props) {
        super(props);

        this.state = {
            popupVisible: false,
            type: 'mobile',
            valueToVerify: '',
            errorValueVerify: null,
            selectedIndex: null,
            selectError: null,
        }

        this.renderThe1CardChoice = this.renderThe1CardChoice.bind(this);
        this.openPopup = this.openPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.closeWithOnlyCard = this.closeWithOnlyCard.bind(this);
        this.setType = this.setType.bind(this);
        this.getThe1TypeLabel = this.getThe1TypeLabel.bind(this);
        this.setThe1ValueCheck = this.setThe1ValueCheck.bind(this);
        this.verify = this.verify.bind(this);
        this.renderPopupContent = this.renderPopupContent.bind(this);
        this.selectCardandClose = this.selectCardandClose.bind(this);
    }

    renderThe1CardChoice(cards) {
        const { translate } = this.props
        return _.map(cards, (card, n) => {
            return (
                <div key={card.cardNo} className="col-12 mb-4">
                    <label className="radio-container">
                        <div className="d-flex flex-column" style={{ fontSize: "14px", lineHeight: "16px" }}>
                            <span className="" style={{ lineHeight: "16px" }}>{card.first_name.th} {card.last_name.th ? card.last_name.th.substring(0, 5) + '*****' : ''}</span>
                            <span className="" style={{ lineHeight: "16px" }}>{translate('THE1_FORM.CARD_NO')}:<span className=""> {card.cardNo}</span></span>
                            {/* <span className="">คะแนนปัจจุบัน:<span className="">{card.pointsBalance}</span></span> */}
                        </div>
                        <input type="radio" name="the1card" value={card.cardNo} checked={this.state.selectedIndex === n} onChange={() => this.setState({ selectedIndex: n })} />
                        <span className="selectmark"><FontAwesomeIcon icon={["fas", "circle"]} /></span>
                    </label>
                </div>
            );
        })
    }

    openPopup() {
        this.setState({
            popupVisible: true,
        })
    }

    closePopup() {
        this.setState({
            type: 'mobile',
            valueToVerify: '',
            errorValueVerify: null,
            popupVisible: false,
            selectedIndex: null,
            selectError: null,
        });
        this.props.clearThe1Verify();
    }

    closeWithOnlyCard() {
        const { input, cards } = this.props;
        input.onChange(cards[0].cardNo);
        this.closePopup();
    }

    setType(v) {
        this.setState({
            type: v,
        })
    }

    getThe1TypeLabel() {
        const { type } = this.state;
        let matchType = _.find(the1Types, (t) => t.value === type);
        if (matchType) {
            return matchType.label;
        }
        return 'กรุณาเลือกประเภทการตรวจสอบค่ะ';
    }

    setThe1ValueCheck(e) {
        this.setState({
            valueToVerify: e.target.value,
        });
    }

    verify() {
        const { type, valueToVerify } = this.state;
        if (valueToVerify === '') {
            this.setState({
                errorValueVerify: 'ไม่สามารถเว้นว่างค่ะ',
            })
            return;
        }
        let objToVerify = {};
        if (type === 'mobile') {
            objToVerify = { "phoneNumber": valueToVerify }
        }
        this.props.verifyThe1(type, objToVerify);
    }

    selectCardandClose() {
        const { selectedIndex } = this.state;
        const { input, cards } = this.props;
        if (selectedIndex === null) {
            this.setState({
                selectError: 'โปรดเลือกหมายเลข The1 ค่ะ',
            });
            return;
        }
        input.onChange(cards[selectedIndex].cardNo);
        this.closePopup();
    }

    renderPopupContent() {
        const { translate, verifyResult, verifyError, cards, input } = this.props;
        const { valueToVerify, errorValueVerify, selectError } = this.state;
        if (verifyResult) {
            if (_.get(cards, 'length', 0) === 1) {

                return (
                    <React.Fragment key={'the1_verify_content'}>
                        <div className="col-12 mt-5 text-center">หมายเลข The1 ของคุณคือ {cards[0].cardNo}</div>
                        <div className="col-12 py-3 text-center">
                            <button className="btn-primary" style={{ borderRadius: "16px", padding: "5px 20px" }} type="button" onClick={this.closeWithOnlyCard}>{translate('THE1_FORM.CONFIRM')}</button>
                        </div>
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment key={'the1_verify_content'}>
                    <div className="col-12 text-center mb-5">ตรวจสอบหมายเลข The1</div>
                    <label className="btn-close" style={{ zIndex: 1 }} onClick={this.closePopup}><FontAwesomeIcon icon={["fal", "times"]} style={{ height: "16px", width: "16px", color: "#fff", backgroundColor: "#ccc" }} /></label>
                    <div className="">
                        {this.renderThe1CardChoice(cards)}
                    </div>
                    {selectError && <div className="col-12 text-center text-danger">
                        {selectError}
                    </div>}
                    <div className="col-12 py-3 text-center">
                        <button className="btn-primary" style={{ borderRadius: "16px", padding: "5px 20px" }} type="button" onClick={this.selectCardandClose}>{translate('THE1_FORM.CONFIRM')}</button>
                    </div>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment key={'the1_verify_content'}>
                <label className="btn-close" style={{ zIndex: 1 }} onClick={this.closePopup}><FontAwesomeIcon icon={["fal", "times"]} style={{ height: "16px", width: "16px", color: "#fff", backgroundColor: "#ccc" }} /></label>
                <div className="col-12 text-center mb-5">ตรวจสอบหมายเลข The1</div>
                <div className="col-12 ">
                    <SelectField
                        placeholder={'กรุณาเลือกประเภทการตรวจสอบ'}
                        options={the1Types}
                        onChange={this.setType}
                        initValue={{ value: 'mobile', label: 'หมายเลขโทรศัพท์' }}
                    />
                </div>
                <div className="col-12 pt-2">
                    <div className={`form-group ${errorValueVerify ? "has-danger" : ""}`}>
                        {/* <label className={`form-control-label`}>{(_.find(the1Types, (t) => t.value === this.state.type)).label}</label> */}
                        <input value={valueToVerify} className={`form-control`} type={'text'} placeholder={this.getThe1TypeLabel()} onChange={this.setThe1ValueCheck} />
                        {errorValueVerify ? <small className="color-red ml-1">{errorValueVerify}</small> : null}
                    </div>
                </div>
                {verifyError && <div className="col-12 text-center text-danger">
                    {verifyError}
                </div>}
                <div className="col-12 py-3 text-center">
                    <button className="btn-white mr-3" style={{ borderRadius: "16px", padding: "5px 20px" }} type="button" onClick={this.closePopup}>{translate('THE1_FORM.CANCEL')}</button>
                    <button className="btn-primary" style={{ borderRadius: "16px", padding: "5px 20px" }} type="button" onClick={this.verify}>{translate('THE1_FORM.CONFIRM')}</button>
                </div>
            </React.Fragment>
        );
    }

    render() {
        const { input, id, label, type, pattern, inputmode, placeholder, className, labelClassName, inputClassName, autocomplete, translate, meta: { error } } = this.props;
        const { popupVisible, } = this.state;
        let customClassName = className ? className : '';
        let labelCustomClassName = labelClassName ? labelClassName : '';
        let inputCustomClassName = inputClassName ? inputClassName : '';
        let customAutoComplete = autocomplete ? autocomplete : '';
        let errorText = (translate && isLangKeyExisted(error)) ? translate(error) : error;
        return (
            <>
                <div className={`form-group ${error ? "has-danger" : ""} ${customClassName}`}>
                    {label && <label className={`form-control-label ${labelCustomClassName}`}>{label} {error && <small className="color-red ml-1">{errorText}</small>}</label>}
                    <input {...input} id={id} className={`form-control ${inputCustomClassName}`} type={type} placeholder={placeholder} autoComplete={customAutoComplete} readOnly={true} pattern={pattern} inputMode={inputmode} onClick={this.openPopup}
                        onChange={(e) => {
                            if (type === "datetime-local") {
                                input.onChange(toDatetimeLocal(new Date(e.target.value)))
                            } else {
                                input.onChange(e)
                            }
                        }} />
                    {!label ? error ? <small className="color-red ml-1">{errorText}</small> : null : null}
                </div>
                {popupVisible && <div className="bt-popup-backdrop">
                    <div className="bt-popup">
                        <div className="container py-3" style={{ minWidth: 300, }}>
                            <div className="row content-part">
                                {this.renderPopupContent()}
                            </div>
                        </div>
                    </div>
                </div>}
            </>
        );
    }
}

export const The1Field = connect((state) => ({
    translate: getTranslate(state.locale),
    cards: state.the1.cards,
    verifyResult: state.the1.verifyResult,
    verifyError: state.the1.verifyError,
}), { verifyThe1, clearThe1Verify })(_The1Field);